export default __webpack_public_path__ + "static/media/general-error.d105e528.svg";